function InstagramIcon({ size = "24", color = "#b1272c" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24.516 24.511"
    >
      <path
        id="Icon_awesome-instagram"
        data-name="Icon awesome-instagram"
        d="M12.255,8.209a6.284,6.284,0,1,0,6.284,6.284A6.274,6.274,0,0,0,12.255,8.209Zm0,10.37a4.086,4.086,0,1,1,4.086-4.086,4.093,4.093,0,0,1-4.086,4.086ZM20.263,7.952A1.466,1.466,0,1,1,18.8,6.486,1.462,1.462,0,0,1,20.263,7.952Zm4.162,1.488A7.254,7.254,0,0,0,22.445,4.3a7.3,7.3,0,0,0-5.136-1.98c-2.024-.115-8.089-.115-10.113,0A7.291,7.291,0,0,0,2.061,4.3,7.277,7.277,0,0,0,.081,9.434c-.115,2.024-.115,8.089,0,10.113a7.254,7.254,0,0,0,1.98,5.136A7.311,7.311,0,0,0,7.2,26.662c2.024.115,8.089.115,10.113,0a7.254,7.254,0,0,0,5.136-1.98,7.3,7.3,0,0,0,1.98-5.136c.115-2.024.115-8.084,0-10.107ZM21.81,21.718a4.136,4.136,0,0,1-2.33,2.33c-1.613.64-5.442.492-7.225.492s-5.617.142-7.225-.492a4.136,4.136,0,0,1-2.33-2.33c-.64-1.613-.492-5.442-.492-7.225S2.066,8.876,2.7,7.268a4.136,4.136,0,0,1,2.33-2.33c1.613-.64,5.442-.492,7.225-.492s5.617-.142,7.225.492a4.136,4.136,0,0,1,2.33,2.33c.64,1.613.492,5.442.492,7.225S22.45,20.11,21.81,21.718Z"
        transform="translate(0.005 -2.238)"
        fill={color}
      />
    </svg>
  );
}

export default InstagramIcon;
